export const environment = {
    production: false,
    host: "https://stage.moony.tips",
    port: 0,
    preUrl: "/api/v1"
};